import { Box } from "@mui/material";
import { Pill } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";
import { formatDayOfMonthWithDayName } from "@src/appV2/redesign/utils/formatDayOfMonthWithDayName";

export function DatePill({ startDate }: { startDate: Date }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        ...(isRebrandingEnabled() && { marginBottom: 2 }),
      }}
    >
      <Pill
        variant="outlined"
        sx={{ backgroundColor: (theme) => theme.palette.background.paper }}
        label={formatDayOfMonthWithDayName(startDate)}
      />
    </Box>
  );
}
